import { ACTIONS_MINE_PLAN } from '_constants/mineplan.constants';
import mineplanService from '_services/mineplans.service';
import machineMinePlanActions from './machineMinePlan.actions';
import alertActions from './alert.actions';

const receiveMinePlans = (mineplans) => {
  const byIdObjectToDispatch = {};

  for (let i = 0; i < mineplans?.length; i++) {
    byIdObjectToDispatch[mineplans[i].minePlanID] = mineplans[i];
  }

  return {
    type: ACTIONS_MINE_PLAN.RECEIVE,
    byId: byIdObjectToDispatch,
  };
};

const deletePlan = (minePlanID) => ({
  type: ACTIONS_MINE_PLAN.DELETE,
  byId: { [minePlanID]: null }, // defaulted
});

const getMinePlans = (accountID) => async (dispatch) => {
  try {
    const resp = await mineplanService.getAll(accountID);
    dispatch(receiveMinePlans(resp));
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const getMinePlan = (minePlanID) => async (dispatch) => {
  try {
    const resp = await mineplanService.getById(minePlanID);
    dispatch(receiveMinePlans([ resp ]));
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const addMinePlan = (minePlan) => async (dispatch) => {
  try {
    const resp = await mineplanService.create(minePlan);
    if (resp.success) {
      dispatch(receiveMinePlans([ resp.minePlan ]));
    }
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const updMinePlan = (minePlan) => async (dispatch) => {
  try {
    const resp = await mineplanService.update(minePlan);
    dispatch(receiveMinePlans([ resp ]));
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const deleteMinePlan = (minePlanID) => async (dispatch) => {
  try {
    const resp = await mineplanService.del(minePlanID);
    if (resp?.minePlanID) {
      await dispatch(deletePlan(resp.minePlanID));
      // On mineplan delete also invalidate the related machineMinePlans
      await dispatch(machineMinePlanActions.invalidate());
    }
    return resp;
  } catch (e) {
    dispatch(alertActions.error(e.Message, e));
  }
  return null;
};

const minePlanActions = {
  updMinePlan,
  addMinePlan,
  deleteMinePlan,
  getMinePlan,
  getMinePlans
};

export default minePlanActions;
